import React from 'react';
import Testimonials from './Testimonials';
import News from './News';
import '../styles/TestimonialsNewsSection.css';

const TestimonialsNewsSection = () => {
  return (
    <section id="testimonials-news" className="testimonials-news-section">
      <div className="testimonials-news-container">
        <Testimonials />

        <News />
      </div>
    </section>
  );
};

export default TestimonialsNewsSection;
